module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_2_1_drag_4.570364ed.png";